<template>
    <div>
        <div v-if="loaded && count > 1" class="mb-2">
            <div>
                <p class="font-sm text-elev-blue-dim mb-2"><strong>{{ $t('Produkt') }}</strong></p>
                <select name="teacher-select" class="form-select" v-model="id" @change="select">
                    <option :value="null" :selected="id === null">- {{ $t('calendar.select-product') }} -</option>
                    <template v-for="group in list">
                        <optgroup :label="group.name" v-if="group.list.length">
                            <option v-for="(product, i) in group.list" :value="product.product_id" :selected="isSelected(product.product_id)">{{ product.product_name }}</option>
                        </optgroup>
                    </template>
                </select>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import Api from '../../api/Calendar.js'

const emits = defineEmits(['loaded', 'change'])

const loaded = ref(false)
const id = ref(null)
const products = ref([])
const list = ref([])

// Computed
const count = computed(() => {
    if (!products.value) {
        return 0;
    }
    return products.value.length
})

// Methods
function getProducts() {
    Api.GetProducts().then(res => {
        list.value = res.productTypes || []
        products.value = res.products || []

        emits('loaded')
        loaded.value = true

        if (res.products.length === 1) {
            const currentProduct = res.products[0]
            id.value = currentProduct?.product_id ?? null
            emits('change', { 
                productId: currentProduct?.product_id ?? null,
                productType: currentProduct?.product_type ?? null,
            })
        }
    })
}

function select() {
    const product = products.value.find(p => p.product_id === id.value)
    emits('change', {
        productId: product?.product_id ?? null,
        productType: product?.product_type ?? null,
    })
}

function isSelected(productId) {
    if (productId === null && id.value === null) {
        return true
    }
    return parseInt(productId) === id.value
}

// Lifecycle
onMounted(() => {
    getProducts()
})
</script>